<template>
  <div v-if="image" class="w-3/5 md:w-1/2 lg:w-2/5 mt-25 lg:mt-30">
    <component :is="is" v-bind="attributes">
      <MediaImage v-bind="image" :image-style="imageStyle" />
    </component>
  </div>
</template>

<script lang="ts" setup>
import type { TaxonomyTermMatTechnologiesFragment } from '#build/graphql-operations'

const props = defineProps<{
  id?: string
  name?: string
  link?: TaxonomyTermMatTechnologiesFragment['link']
  image?: TaxonomyTermMatTechnologiesFragment['image']
}>()

const href = computed(() => props.link?.url?.path)
const is = computed(() => (href.value ? 'a' : 'div'))
const attributes = computed(() => (href.value ? { href: href.value } : {}))

const imageStyle = defineImageStyle({
  type: 'sizes',
  sizes: {
    xs: 375,
    sm: 500,
  },
})
</script>
